import { DEFAULT, SHORT, NUMERIC, VALID_FORMATS } from './consts';
import { isValidDate, getValidLocale, isNumber } from './helpers';
/**
 * `displayDate` takes a `Date` object and a format specifier, and returns a string representing date that is formatting according to format for the user's locale.
 * @param date - `Date` object or `number` to display as `string`.
 * @param options - options object can contain following fields:
 *   * `format` - either "default", "short", or "numeric".
 *   * `locale` - developer designated locale (this will take precedence over browser setting, if language differs).
 *   * `utc` - converts `date` to UTC timezone if true. Defaults to false.
 * @returns a locale date string corresponding to current user's locale and format options.
 */

export var displayDate = function displayDate(date) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!isValidDate(date)) {
    throw new TypeError("The first argument must be a valid date but was \"".concat(date, "\"."));
  }

  var format = options.format,
      locale = options.locale,
      utc = options.utc,
      weekday = options.weekday,
      year = options.year;

  if (!VALID_FORMATS.has(format)) {
    var supported = Array.from(VALID_FORMATS).filter(function (f) {
      return !!f;
    }).map(function (f) {
      return JSON.stringify(f);
    });
    supported[2] = "or ".concat(supported[2]);
    throw new TypeError("The format must be either: ".concat(supported.join(', '), " but was \"").concat(format, "\"."));
  }

  var _options = {};
  _options.day = NUMERIC;
  _options.year = NUMERIC;

  switch (format) {
    case NUMERIC:
      _options.month = NUMERIC;
      break;

    case SHORT:
    case DEFAULT:
    default:
      _options.month = SHORT;

      if (weekday) {
        _options.weekday = SHORT;
      }

      if (year === false) {
        delete _options.year;
      }

      break;
  }

  if (utc) {
    _options.timeZone = 'UTC';
  }

  var localeId = getValidLocale(locale);
  var finalDate = isNumber(date) ? new Date(date) : date;
  return finalDate.toLocaleDateString(localeId, _options);
};
//# sourceMappingURL=displayDate.js.map